module.exports = __webpack_public_path__ + "img/parpar_no.1e6119be.png";